import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "visibility", "invitees", "fixedFields", "flexibleFields", "capacityMode" ]

  connect() {
    this.updateVisibility()
    this.updateCapacity()
  }

  updateVisibility() {
    if (!this.hasInviteesTarget || !this.hasVisibilityTarget) return

    const invite = this.selectedVisibility() === "invite_only"
    this.inviteesTarget.classList.toggle("hidden", !invite)
  }

  updateCapacity() {
    const fixed = this.capacityModeTargets.find((el) => el.checked)?.value === "fixed"
    this.fixedFieldsTarget.classList.toggle("hidden", !fixed)
    this.flexibleFieldsTarget.classList.toggle("hidden", fixed)
  }

  selectedVisibility() {
    const selected = this.visibilityTargets.find((el) => el.checked)
    return selected?.value
  }
}
